module.exports = __webpack_public_path__ + "static/media/symmetric.874849a7.svg";